define('router',['require','backbone','marionette'],function(router){

	var Backbone = require('backbone');
	require('marionette');

	return Backbone.Marionette.AppRouter.extend({

		appRoutes: {
			"": "home",
            "signin(/)": "signin",
            "forgot-password(/)": "forgotPassword",
            "reset-password/:resetCode(/)": "resetPassword",
            "settings(/)": "settings",
            "reseller-application": "resellerApplication",
            "distributor-application": "distributorApplication",
            "customer-application": "customerApplication",
            "customer-registration": "customerRegistration",

            "country-distributors(/)": "country_distributors",
            "country-distributors/new(/)": "newCountryDistributor",
            "country-distributors/:distributorId(/)": "country_distributor",
            "cd-managers(/)": "cdManagers",
            "cd-managers/:managerId(/)": "cdManager",

            "distributors(/)": "distributors",
            "distributors/new(/)": "newDistributor",
            "distributors/:distributorId(/)": "distributor",
            "distributor-managers(/)": "distributorManagers",
            "distributor-managers/:managerId(/)": "distributorManager",

            "resellers(/)": "resellers",
            "resellers/new(/)": "newReseller",
            "resellers/:resellerId(/)": "reseller",
            "reseller-managers(/)": "resellerManagers",
            "reseller-managers/:managerId(/)": "resellerManager",

            "customers(/)": "customers",
            "customers/new(/)": "newCustomer",
            "customers/:resellerId(/)": "customer",
            "customer-managers(/)": "customerManagers",
            "customer-managers/:managerId(/)": "customerManager",

            "leads(/)": "leads",
            "leads/new(/)": "newLead",
            "leads/:leadId(/)": "lead",

            "products(/)": "products",
            "products/new(/)": "newProduct",
            "products/:productId(/)": "product",
            "product-categories(/)": "productCategories",
            "product-categories/new(/)": "newProductCategory",
            "product-categories/:categoryId(/)": "productCategory",

            "store(/)": "store",
            "checkout(/)": "checkout",
            "market(/)": "market",
            "market-usa(/)": "marketUsa",

            "licenses(/)": "licenses",
            "licenses/:licenseId(/)": "license",
            "periodic-licenses(/)": "periodicLicenses",
            "recurring-licenses(/)": "recurringLicenses",
            "recurring-licenses/:licenseId(/)": "recurringLicense",

            "orders(/)": "orders",

            "get-payment(/)": "getPayment",
            "payments(/)": "payments",
            "payments/:paymentId(/)": "payment",

            "reports/sales(/)": "salesReports",
            "reports/distributor-sales(/)": "distributorSalesReports",
            "reports/reseller-sales(/)": "resellerSalesReports",
            "reports/country-sales(/)": "countrySalesReports",
            "reports/leads(/)": "leadsReports",
            "reports/inactive-distributors(/)": "inactiveDistributorsReports",
            "reports/inactive-resellers(/)": "inactiveResellersReports",
            "reports/comparison(/)": "comparisonReports",
            "reports/ip-history(/)": "ipHistoryReports",
            "reports/distributor-revenues(/)": "distributorRevenueReports",
            "reports/cd-stocks(/)": "cdStockReports",
            "reports/distributor-stocks(/)": "distributorStockReports",
            "reports/distributor-activity(/)": "distributorActivityReports",
            "reports/reseller-revenues(/)": "resellerRevenueReports",
            "reports/reseller-stocks(/)": "resellerStockReports",
            "reports/reseller-activity(/)": "resellerActivityReports",
            "reports/applications(/)": "applicationReports",
            "reports/upcoming-licenses(/)": "upcomingLicenses",
            "reports/distributor-data(/)": "distributorReports",
            "reports/reseller-data(/)": "resellerReports",
            "reports/customer-data(/)": "customerReports",
            
            "personals(/)" : "personals",
            "personals/new(/)" : "newPersonal",
            "personals/:personalId(/)":"personal",

            "personal-roles(/)":"personalRoles",
            "personal-roles/new(/)":"newPersonalRole",  
            "personal-roles/:roleId(/)":"personalRole",

            "blacklist(/)": "blacklist",

            "wallets(/)": "wallets",

            "timeline(/)": "timeline",

            "metrik(/)": "metrik",
            "metrik-user-registration/:registerCode(/)": "metrikUserRegistration",

            "verify(/)":  "verify",
            "verify/:registerCode":  "verify",

            "go-orders/:productId(/)": "goOrders",
            "go-order/:licenseId(/)": "goOrder"
		}

	});

});

